import { useState, useEffect} from 'react';
import logo from '../../assets/logo.svg';
function Login() {
	const [shop, setShop] = useState<string>('')
	const [shopRegistered, setShopRegistered] = useState<string>('')

	useEffect(() => {
		let shopItem: any = localStorage.getItem('shop')
		if (shopItem) {
			try {
				shopItem = JSON.parse(shopItem)

				if (shopItem?.myshopifyDomain) {
					setShopRegistered(shopItem?.myshopifyDomain)
				}
			} catch (e) {
				console.error(e)
			}
		}
	}, [])
	return (
		<div className="login">
			<div className="login__container">
				<img src={logo} className="login__logo" alt="logo" />

				{ shopRegistered ? 
					<a  className="login__btn-logregister" href={`${process.env.REACT_APP_API_URL}/auth/app?shop=${shopRegistered}`}>
						{shopRegistered}
					</a >
				: ''}

				<div className="login__shop">
					<input className="login__shop-input" type="text" placeholder="" value={shop} onChange={e => setShop(e.target.value)}/>
					<div className="login__shop-placeholder">
						<span className="login__shop-placeholder-text">.myshopify.com</span>
					</div>
				</div>

				<a className="login__btn-log" href={`${process.env.REACT_APP_API_URL}/auth/app?shop=${shop}.myshopify.com`}>
					Login
				</a>
			</div>
		</div> 
	);
}

export default Login;
